<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-04 16:54:01
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-04-28 08:29:57
 * @FilePath: \sns-user-frontend\src\views\home\web\rankList.vue
 * @Description: 
-->
<template>
  <div class="rank-list">
    <el-skeleton :loading="loading" :throttle="500" animated>
      <template #template>
        <el-skeleton-item variant="p" style="height: 42px; margin-bottom: 16px;"/>
        <div v-for="i in 5" :key="i" style="display: flex; align-items: center;justify-items:space-between;margin-bottom:24px;">
          <el-skeleton-item variant="image" style="width: 48px; height: 48px;margin-right: 8px; border-radius: 50%;" />
          <div style="flex:1; margin-right: 14px;">
            <el-skeleton-item variant="text" style="width: 30%" />
            <el-skeleton-item variant="text" style="width: 100%" />
          </div>
          <el-skeleton-item variant="text" style="width: 74px; height: 38px; border-radius: 100px;" />
        </div>
      </template>
      <template #default>
        <div
          v-for="({type, list, label}, indexF) in rankTypeList"
          :key="indexF"
          :class="list.length ? 'mb' : ''"
        >
          <template v-if="list.length">
          <!-- 排行榜类型：最佳创作着、活跃排行榜 -->
            <span class="rank-title">{{$t(label)}}</span>
            <div
              :class="`rank ${type}`"
              v-for="({
                uid,
                userIcon, 
                nickName, 
                relation,
                signature,
                userAvatar
              }, indexS) in list"
              :key="indexS"
            >
              <!-- 活跃排名 -->
              <span v-if="type === 'active'">{{indexS + 1}}</span>
              <Avatar
                :avatarInfo="{
                  id: uid,
                  icon: userIcon,
                  avatar: userAvatar
                }"
                :size="48"
                :iconSize="13"
              >
                <!-- 昵称、签名 -->
                <dl>
                  <dt class="rank-nickname">{{nickName}}</dt>
                  <dt class="rank-signature">{{signature}}</dt>
                </dl>
              </Avatar>
              <!-- 关注按钮 -->
              <transition name="fade">
                <Follow 
                  v-if="list[indexS].relation <= 1"
                  v-model:relation="list[indexS].relation" 
                  :uid="uid" 
                  :followFrom="label"
                />
              </transition>
            </div>
          </template>
        </div>
      </template>
    </el-skeleton>
    <Footer />
  </div>
  
</template>

<script setup>
import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import http from '@/service'

const systemStore = useSystemStore() 
const { customSetting } = storeToRefs(systemStore) 

const loading = ref(true)
const rankTypeList = reactive([{
  type: 'topCreators',
  label: 'topCreators',
  list: []
}, {
  type: 'active',
  label: 'activeRanking',
  list: []
}])

onMounted(async () => {
  // 获取排行榜数据
  const { data: topCreatorList } = await http.getTopCreators()
  if (topCreatorList && topCreatorList.rows.length) {
    rankTypeList[0].list = [...topCreatorList.rows]
  }
  if (!customSetting.value.hideInspirationBoard) {
    const { data: activeRankingList} = await http.getActiveRanking({ count: 5 })
    if (activeRankingList && activeRankingList.length) {
      rankTypeList[1].list = [...activeRankingList]
    }
  }
  loading.value = false
})

</script>
<style lang="postcss" scoped>
  .rank-list {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 312px;
    min-height: 370px;
    position: sticky;
    top: calc(var(--orbit-notice-height, 0px) + var(--orbit-nav-height, 0px) + 50px);
    height: fit-content;
    .mb {
      margin-bottom: 96px;
    }
    .rank {
      width: 312px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        font-style: italic;
        font-size: 18px;
        line-height: 120%;
        color: var(--text-primary);
        margin-right: 16px;
      }
      dl {
        margin: 0 8px 0;
      }
      a:hover {
        color: unset;
      }
      &-nickname {
        flex: 1;
        font-size: 18px;
        line-height: 26px;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        margin-bottom: 4px;
      }
      &-signature {
        font-size: 14px;
        line-height: 23px;
        color: var(--text-hint);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
      }
    }
  }
  .rank-title {
    display: flex;
    align-items: flex-start;
    width: 312px;
    font-size: 28px;
    height: 44px;
    margin-bottom: 16px;
    /* border-bottom: 2px solid var(--line); */
    font-family: "orbit-R";
    font-weight: normal;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      border-bottom: 1px solid var(--color-divider-primary);
      width: 100%;
    }
  }
  /* transition内置组件 渐出样式 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }
  /* 底部样式 */
  :deep(.footer) {
    font-size: 12px;
    width: 312px;
    min-width: 312px;
    background: none;
    height: auto;
    position: static;
    .footer-main {
      flex-flow: column-reverse;
      align-items: flex-start;
      width: 100%;
      .footer-l {
        width: 100%;
        color: var(--text-hint);
        padding-bottom: 36px;
        display: flex;
        flex-wrap: wrap;
        dl {
          flex-wrap: wrap;
          margin-bottom: 4px;
        }
        dt {
          position: relative;
          padding: 0;
          margin-right: 12px;
          border: none;
          line-height: normal;
          &:first-child {
            &::after {
              display: none;
            }
          }
          &::after {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            content: '';
            width: 1px;
            height: 14px;
            /* border-left: 1px solid var(--line); */
          }
        }
        /* a:hover {
          color: rgba(0, 0, 0, .55) !important;
        } */
      }
      .footer-r {
        margin-bottom: 8px;
        a {
          margin-right: 12px;
        }
      }
      a {
        font-size: 12px !important;
        color: var(--color-text-disabled);
        &:hover {
          color: rgba(0, 0, 0, .55);
          /* cursor: pointer; */
        }
      }
    }
  }
</style>